const messages = {
    title: "Vzdrževalna dela",
    description: "Trenutno potekajo potrebna vzdrževalna dela na strežnikih." +
        "<br/><br/>Posledično je dostop do <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b> " +
        "trenutno nedostopen.<br/><br/>Zahvaljujemo se vam za potrpežljivost in razumevanje." +
        "<br/><br/> Vaš Bridgestone tim"
}
export default {
    messages
}
